const getters = {
  currPatientName: (state) => state.home.currPatientName,
  dateFormat: (state) => state.home.dateFormat,
  remoteServerState: (state) => state.home.remoteServerState,
  camraMode: (state) => state.capture.camraMode,
  casePath: (state) => state.topography.casePath,
  zernikeViewParams: (state) => state.topography.zernikeViewParams,
  dataShowSettings: (state) => state.topography.dataShowSettings,
  mapDrawSettings: (state) => state.topography.mapDrawSettings,
  zernikeSet: (state) => state.topography.zernikeSet,
  zernikeParams: (state) => state.topography.zernikeParams,
  loginState: (state) => state.home.loginState,
  isHasUrl: (state) => state.home.isHasUrl,
  vncControl: (state) => state.home.vncControl,
  cameraInited: (state) => state.capture.isInited,
  camera: (state) => state.capture.cameraInStance
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js